var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-hero",style:(`${_vm.image}${_vm.color}`)},[_c('v-container',{class:`d-flex align-center app-hero-content ${_vm.hasMask && 'has-mask'}`},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }